import { useDataProvider } from '../../hooks/dataProvider'
import ThemeFooter from './ThemeFooter'

export default function WebsiteFooter() {
    const { data } = useDataProvider()
    if (data?.showFooter === false) return null
    return <ThemeFooter />
}
